<template>
  <div class="fixed inset-0 z-overlay flex items-center justify-center bg-overlay">
    <Spinner class="size-12 text-foreground" :aria-label="label" />
  </div>
</template>

<script setup>
import { Spinner } from '@kate/components/ui';

defineProps({
  label: { type: String, default: 'Loading' },
});
</script>
